/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { MetaData } from './meta-data';
// May contain unused imports in some cases
// @ts-ignore
import type { Optimization } from './optimization';
// May contain unused imports in some cases
// @ts-ignore
import type { Region } from './region';

/**
 * A cluster.
 * @export
 * @interface Cluster
 */
export interface Cluster {
    /**
     * Cast AI cluster ID - is onboarded if set.
     * @type {string}
     * @memberof Cluster
     */
    'castAiId'?: string;
    /**
     * Cloud provider.
     * @type {string}
     * @memberof Cluster
     */
    'cloud'?: ClusterCloudEnum;
    /**
     * The cloud cluster ID of the cluster
     * @type {string}
     * @memberof Cluster
     */
    'cloudId'?: string;
    /**
     * Cluster creation timestamp.
     * @type {string}
     * @memberof Cluster
     */
    'createTime'?: string;
    /**
     * Error.
     * @type {Error}
     * @memberof Cluster
     */
    'error'?: Error;
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof Cluster
     */
    'id'?: string;
    /**
     * Cluster metadata.
     * @type {MetaData}
     * @memberof Cluster
     */
    'metadata'?: MetaData;
    /**
     * Cluster name
     * @type {string}
     * @memberof Cluster
     */
    'name'?: string;
    /**
     * Cluster optimization details.
     * @type {Optimization}
     * @memberof Cluster
     */
    'optimization'?: Optimization;
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof Cluster
     */
    'organizationId'?: string;
    /**
     * Provider namespace ID, e.g. AWS account ID, Azure subscription ID, GCP project ID.
     * @type {string}
     * @memberof Cluster
     */
    'providerNamespaceId'?: string;
    /**
     * Provider type.
     * @type {string}
     * @memberof Cluster
     */
    'providerType'?: ClusterProviderTypeEnum;
    /**
     * Region where the cluster is located.
     * @type {Region}
     * @memberof Cluster
     */
    'region'?: Region;
    /**
     * Cluster update time
     * @type {string}
     * @memberof Cluster
     */
    'updateTime'?: string;
    /**
     * Version of the cluster.
     * @type {string}
     * @memberof Cluster
     */
    'version'?: string;
}

export const ClusterCloudEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;

export type ClusterCloudEnum = typeof ClusterCloudEnum[keyof typeof ClusterCloudEnum];
export const ClusterProviderTypeEnum = {
    PROVIDER_TYPE_UNSPECIFIED: 'PROVIDER_TYPE_UNSPECIFIED',
    GKE: 'GKE',
    EKS: 'EKS',
    AKS: 'AKS'
} as const;

export type ClusterProviderTypeEnum = typeof ClusterProviderTypeEnum[keyof typeof ClusterProviderTypeEnum];


